import NodeLabel from "Areas/SharedFeatures/nodeLabel";
import React from "react";
import ReactDOMServer from "react-dom/server";
import { NODE_MAX_SIZE, NODE_MIN_SIZE, NODE_ROUND_RADIUS } from "../../constants";
import setNodeLayout from "./setNodeLayout";
const graphNodeLabelDetailedStyle = {
    padding: "6px 0",
    minHeight: NODE_MIN_SIZE.height - 5,
    margin: "1px 0",
    borderTopRightRadius: NODE_ROUND_RADIUS,
    borderBottomRightRadius: NODE_ROUND_RADIUS
};
export default (graphComponentRef, node, documentObject) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) || !node || !node.tag)
        return;
    const nodeCanvas = graphComponentRef.current.graphModelManager.getCanvasObject(node);
    if (!nodeCanvas)
        return;
    node.labels.toArray().forEach(label => {
        var _a;
        ((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) && graphComponentRef.current.graph.remove(label);
    });
    const label = graphComponentRef.current.graph.addLabel(node, ReactDOMServer.renderToStaticMarkup(React.createElement(NodeLabel, { imgSize: 0, data: node.tag, documentObject: documentObject, style: graphNodeLabelDetailedStyle, titleMaxLength: 60, whiteSpace: "inherit", showDocumentObjectName: true })));
    const labelCanvas = graphComponentRef.current.graphModelManager.getCanvasObject(label);
    labelCanvas && labelCanvas.above(nodeCanvas);
    setNodeLayout(graphComponentRef.current.graph, node, undefined, NODE_MAX_SIZE, true);
};
